import Constants from '../../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}depuber/`;

const title = "Holy Road - De Puber";
const description = "Emuna is veertien. Ze had een dansvoorstelling, samen met haar vriendin Hallel. Vlak voor het optreden werd Hallel doodgestoken. In haar eigen slaapkamer.";
const featuredImage = `${imageFolder}depuber/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}depuber`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Paragraph",
        text: "Zoals alle dertienjarige meisjes had Hallel Yaffe Ariel roze kussens op haar hoogslaper in haar slaapkamer. Op de foto die het Israëlische leger heeft vrijgegeven, is haar bed besmeurd met bloed. Aan de plas op de grond te zien, moet haar Palestijnse moordenaar flink op haar ingestoken hebben voordat ze het leven liet. Drie vriendinnen van Hallel vertellen over hun leven. Hoe zien hun slaapkamers eruit? Hoe heeft de dood van hun vriendin hun levens beïnvloed? En hoe is het eigenlijk om op te groeien in een omstreden nederzetting?"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}00__mobile.jpg`,
            tablet: `${imageFolder}00__tablet.jpg`,
            desktop: `${imageFolder}00.jpg`,
            alt: "",
            text: "Overal bij de familie Ariel in huis hangen foto’s van Hallel en de rest van het gezin"
        }
    },
    {
        type: "Paragraph",
        text: "Emuna danste met Hallel. Heichal was een goede vriendin, geen best friend forever, maar toch. En Noam zat pas twee jaar bij haar in de klas, maar praat nog veel over haar. Hallel Yaffe Ariel was dertien jaar. Ze woonde met haar ouders en twee kleine zusjes in een huis aan de rand van Kiryat Arba, een Joodse nederzetting op de door Israël bezette Westelijke Jordaanoever. Haar vader heeft een wijngaard aan huis."
    },
    {
        type: "Paragraph",
        text: "Waarschijnlijk doordat het ietwat afgelegen is, koos Mohammad Nasser Tra’ayra, een Palestijnse jongen van zeventien, op 30 juni 2016 juist het huis van Hallel uit voor zijn plan om een Joodse kolonist om het leven te brengen. Tra’ayra kwam uit Bani Na’im, een stadje op zes kilometer ten oosten van de nederzetting. Het tienermeisje was alleen thuis. Ze had geen schijn van kans."
    },
    {
        type: "Iframe",
        url: "https://player.vimeo.com/video/209452055",
        text: "Reuters-nieuwsvideo over de dood van Hallel"
    },
    {
        type: "Quote",
        quote: "De avond voor haar dood hebben we nog samen een dansvoorstelling opgevoerd. En vier dagen na haar dood hebben we weer gedanst, om haar te herdenken.",
        person: "Emuna Yeshurun (14), vriendin van Hallel"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}01.jpg`,
            tablet: `${imageFolder}01.jpg`,
            desktop: `${imageFolder}01.jpg`,
            alt: "",
            text: "Emuna op bed in haar slaapkamer"
        }
    },
    {
        type: "Paragraph",
        text: "Emuna, Heichal en Noam zijn nu allemaal veertien. Hoe ingrijpend ook, de dood van hun vriendin is niet het enige trauma dat zij in hun leven hebben meegemaakt. Maar de drie meiden zijn ook gewoon tieners. Emuna draagt een muts, doet aan hiphopdans en is fan van de boyband Big Time Rush. Ze gaat graag met vriendinnen shoppen in het Malha-winkelcentrum in Jeruzalem. Noam, die in een zwaarbewaakt wijkje midden tussen de Palestijnen woont, racet liever keihard de heuvel af in een kruiwagen die aan een fiets is vastgebonden. Al moet ze dan wel oppassen, ‘voor Arabieren en straathonden’. En Heichal schrijft liedjes. Over haar gevoelens."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow1/02__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/02.jpg`,
                desktop: `${imageFolder}slideshow1/02.jpg`,
                alt: "",
                text: "Emuna Yeshurun (14): ‘Ik doe aan hiphop, ballet en moderne dans. Ik kende Hallel erg goed. We zaten bij elkaar in de klas. De avond voor haar dood hebben we nog samen een dansvoorstelling opgevoerd. En vier dagen na haar dood hebben we weer gedanst, om haar te herdenken.’",
            },
            {
                mobile: `${imageFolder}slideshow1/03__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/03.jpg`,
                desktop: `${imageFolder}slideshow1/03.jpg`,
                alt: "",
                text: "‘Ik ben fan van Big Time Rush. Dat is een boyband. Best oud hoor, ze bestaan al niet eens meer.’"
            },
            {
                mobile: `${imageFolder}slideshow1/04__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/04.jpg`,
                desktop: `${imageFolder}slideshow1/04.jpg`,
                alt: "",
                text: "‘Ik wil later gevechtspiloot worden.’"
            },
            {
                mobile: `${imageFolder}slideshow1/05__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/05.jpg`,
                desktop: `${imageFolder}slideshow1/05.jpg`,
                alt: "",
                text: "‘Mijn boodschap aan de wereld is: er zijn hier twee volkeren, maar wij zijn degenen die worden vermoord. Het is niet normaal om de begrafenis van een leeftijdsgenootje te moeten bijwonen.’"
            },
            {
                mobile: `${imageFolder}slideshow1/06__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/06.jpg`,
                desktop: `${imageFolder}slideshow1/06.jpg`,
                alt: "",
                text: "‘Mijn meest waardevolle bezitting? M’n telefoon. En een briefje van Hallel.’"
            },
            {
                mobile: `${imageFolder}slideshow1/07__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/07.jpg`,
                desktop: `${imageFolder}slideshow1/07.jpg`,
                alt: "",
                text: "‘Wij bestuderen op school het joodse leven. Ik vraag me weleens af wat hun eigenlijk geleerd wordt. Waarschijnlijk hoe je Joden moet haten.’"
            },
            {
                mobile: `${imageFolder}slideshow1/08__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/08.jpg`,
                desktop: `${imageFolder}slideshow1/08.jpg`,
                alt: "",
                text: "‘Hallel had nog geen leven, ze was nog niet getrouwd, ze had nog geen kinderen kunnen krijgen. Daar denk ik aan als ik in bed lig. Dan stel ik me voor hoe de steekpartij in z’n werk ging.’"
            },
            {
                mobile: `${imageFolder}slideshow1/09__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/09.jpg`,
                desktop: `${imageFolder}slideshow1/09.jpg`,
                alt: "",
                text: "‘Ik zou niemand kunnen neersteken, al geeft iemand mij een mes en het lichaam van een Arabier. Hoe konden ze het dan doen bij Hallel?’"
            }
        ]
    },
    {
        type: "Paragraph",
        text: "Zoals bijna alle kolonisten van Kiryat Arba zijn Emuna, Heichal en Noam orthodox-joods. Allemaal komen ze uit grote gezinnen – thuis zijn ze respectievelijk met zeven, zes en negen kinderen. Kiryat Arba ligt vlak naast Hebron, waar de Grot van de Patriarchen is. En dat is een van de heiligste plaatsen in het jodendom. Emuna (haar naam betekent ‘geloof’ in het Hebreeuws) gaat elke zaterdag te voet naar de Grot om te bidden."
    },
    {
        type: "Quote",
        quote: "Mijn liedjes gaan over alles, hoe ik me voel. Ik heb niet direct over Hallel geschreven, maar een van de liedjes is wel somber.",
        person: "Heichal Kornstam (14), vriendin van Hallel"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}10__mobile.jpg`,
            tablet: `${imageFolder}10.jpg`,
            desktop: `${imageFolder}10.jpg`,
            alt: "",
            text: "Heichal op bed in haar slaapkamer"
        }
    },
    {
        type: "Paragraph",
        text: "Als een rode draad door hun levens lopen ‘de Arabieren’. Kiryat Arba is een dorp, zoals alle Joodse nederzettingen illegaal volgens het internationaal recht, dat diep op de Westelijke Jordaanoever ligt. Ze worden aan alle kanten door Palestijnen omringd. En die Palestijnen hebben het meer dan eens op hen gemunt."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow2/11__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/11.jpg`,
                desktop: `${imageFolder}slideshow2/11.jpg`,
                alt: "",
                text: "Heichal Kornstam (14): ‘Hallel was heel vriendelijk, ze lachte veel. Heel attent en zorgzaam. We spraken elkaar veel op school. Hebben veel gelachen. Ik zat naast haar bij Engels. Daar was ze goed in.’",
            },
            {
                mobile: `${imageFolder}slideshow2/12__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/12.jpg`,
                desktop: `${imageFolder}slideshow2/12.jpg`,
                alt: "",
                text: "‘Soms gaan we naar Jeruzalem. Om te bowlen, of vrienden te ontmoeten. Ik lees niet meer zo veel, ik maak liever muziek. Ik schrijf liedjes en ik zing. Ik hou van Twenty One Pilots, Bastille.’"
            },
            {
                mobile: `${imageFolder}slideshow2/13__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/13.jpg`,
                desktop: `${imageFolder}slideshow2/13.jpg`,
                alt: "",
                text: "'Mijn liedjes gaan over alles, hoe ik me voel. Ik heb niet direct over Hallel geschreven, maar een van de liedjes is wel somber.’"
            },
            {
                mobile: `${imageFolder}slideshow2/14__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/14.jpg`,
                desktop: `${imageFolder}slideshow2/14.jpg`,
                alt: "",
                text: "'Het ligt aan de Arabieren wat er zal gebeuren. Zij zijn degenen die de aanslagen plegen. De overheid laat het hun toe om hier te leven, en zij plegen aanslagen. Israël stuurt hen niet weg, zeer teleurstellend.’"
            }
        ]
    },
    {
        type: "Paragraph",
        text: "Sommige Joden worden kolonist omdat het zo weids en goedkoop wonen is in een nederzetting. In Kiryat Arba is dat anders. Hier gaat het om de ideologie. Dit land, vinden ze in Kiryat Arba, is van ons. Dat de internationale gemeenschap er anders over denkt, interesseert hen niets. Zij hebben de Thora. En daar staat het. ‘Judea’, zoals zij het zuiden van de Westelijke Jordaanoever noemen, is het hartland van het Joodse volk. "
    },
    {
        type: "Paragraph",
        text: "Deze ideologie heeft zo haar fanatieke kanten. Zo richtte de kolonist Baruch Goldstein uit Kiryat Arba in 1994 een bloedbad aan in de Ibrahimi-moskee, zoals moslims de Grot van de Patriarchen noemen. Hierbij kwamen 29 gelovigen om het leven en raakten er 125 gewond. Goldstein ligt begraven in het Kahane-park in Kiryat Arba, genoemd naar de leider van de extreemrechtse, terroristische organisatie Kach. Het graf is een klein bedevaartsoord voor religieuze nationalisten."
    },
    {
        type: "Quote",
        quote: "We zijn verplicht om met de bus naar school te gaan. De ruiten van de bus zijn kogelwerend, en er rijden bewapende beveiligers mee.",
        person: "Noam Sarah Richie (14), vriendin van Hallel"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}15__mobile.jpg`,
            tablet: `${imageFolder}15.jpg`,
            desktop: `${imageFolder}15.jpg`,
            alt: "",
            text: "Noam op bed in haar slaapkamer"
        }
    },
    {
        type: "Paragraph",
        text: "De ouders van de meiden weten natuurlijk waar ze aan beginnen. Voor de familie van Heichal was Kiryat Arba zelfs een stapje terug in intensiteit: zij woonden aanvankelijk in een Joodse nederzetting in de Gazastrook. Ook Hallel was religieus, zegt haar moeder Rina. De familie Ariel is erg begaan met de beweging die een Derde Joodse Tempel wil bouwen op de Tempelberg/Haram al-Sharif in Oost-Jeruzalem, waar nu twee islamitische gebedshuizen staan."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow3/16__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/16.jpg`,
                desktop: `${imageFolder}slideshow3/16.jpg`,
                alt: "",
                text: "Noam Sarah Richi (14): ‘Het is gevaarlijk om de heuvel af te lopen naar de rest van het dorp. Zelfs te gevaarlijk om naar school te lopen. Er staat een hek om het dorp, maar in dit wijkje wonen we vlak naast de Arabieren.’"
            },
            {
                mobile: `${imageFolder}slideshow3/17__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/17.jpg`,
                desktop: `${imageFolder}slideshow3/17.jpg`,
                alt: "",
                text: "‘We zijn verplicht om met de bus naar school te gaan. De ruiten van de bus zijn kogelwerend, en er rijden bewapende beveiligers mee.’"
            },
            {
                mobile: `${imageFolder}slideshow3/18__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/18.jpg`,
                desktop: `${imageFolder}slideshow3/18.jpg`,
                alt: "",
                text: "Heeft Noam weleens contact met Arabieren? Ze lacht. ‘Nee. Hooguit dat we elkaar uitschelden.’"
            },
            {
                mobile: `${imageFolder}slideshow3/19__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/19.jpg`,
                desktop: `${imageFolder}slideshow3/19.jpg`,
                alt: "",
                text: "‘Ik denk weleens aan Arabische meisjes van mijn eigen leeftijd. Maar ik wil geen contact. Het interesseert me niet zo, ook niet welke muziek ze luisteren. Dat hoor ik wel als ze weer eens een luide bruiloft hebben.’"
            },
            {
                mobile: `${imageFolder}slideshow3/20__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/20.jpg`,
                desktop: `${imageFolder}slideshow3/20.jpg`,
                alt: "",
                text: "‘Mijn zus van achttien doet aan taekwondo, mixed martial arts, boksen en krav maga. Ze heeft het mij ook een beetje geleerd. En er is een zelfverdedigingscursus voor vrouwen. Maar dat helpt niet bij een steekpartij, het is vooral voor je zelfvertrouwen.’"
            },
            {
                mobile: `${imageFolder}slideshow3/21__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/21.jpg`,
                desktop: `${imageFolder}slideshow3/21.jpg`,
                alt: "",
                text: "‘Als iemand mij wil neersteken, gooi ik mijn telefoon naar hem denk ik.’"
            },
            {
                mobile: `${imageFolder}slideshow3/22__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/22.jpg`,
                desktop: `${imageFolder}slideshow3/22.jpg`,
                alt: "",
                text: "‘Een vriendin begon een keer ineens heel hard te schreeuwen, omdat ze zich een voorstelling maakte van de steekpartij.’"
            },
            {
                mobile: `${imageFolder}slideshow3/23__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/23.jpg`,
                desktop: `${imageFolder}slideshow3/23.jpg`,
                alt: "",
                text: "‘Soms is het heel gezellig met de meiden, maar dan denk ik ineens: wat als deze vriendin ook doodgaat?’"
            }
        ]
    },
    {
        type: "Paragraph",
        text: "De meeste vriendinnen van Hallel zien zichzelf wel in Kiryat Arba blijven. De introverte Heichal noemt het ‘teleurstellend’ dat de Israëlische regering de Palestijnen niet wegstuurt. En danseres Emuna vindt dat het haar opdracht is om ook later in Kiryat Arba te blijven wonen: ‘We moeten groeien, anders wordt het hier Arabisch. Alle dorpen om ons heen zijn Arabisch. Als wij groeien, dan slokken we ze op. Dat is de beste manier om terreuraanslagen te voorkomen.’"
    },
]


// WEBPACK FOOTER //
// ./src/data/nl/stories/story1.js